export const LOAD_FORM = "FormModel/LOAD_FORM";
export const REMOVE_FORM = "FormModel/REMOVE_FORM";
export const UPDATE_TERM_VALUES = "FormModel/UPDATE_TERM_VALUES";
export const UPDATE_TERM_VALUE = "FormModel/UPDATE_TERM_VALUE";
export const TERM_INPUT = "FormModel/TERM_INPUT";
export const ITERABLE_COUNT = "FormModel/ITERABLE_COUNT";
export const ITERABLE_ADD = "FormModel/ITERABLE_ADD";
export const ITERABLE_REMOVE = "FormModel/ITERABLE_REMOVE";
export const ITERABLE_MOVE = "FormModel/ITERABLE_MOVE";
export const ACTION_DISPATCH = "FormModel/ACTION_DISPATCH";
//# sourceMappingURL=constants.js.map